import { StoreWrapper } from '@core';

export class ChronodriveStoreWrapper extends StoreWrapper {
  // TODO
  setPos(posExtId) {
    // throw new Error("You must implement 'setPos' for this retailer");
  }

  getPosExtId() {
    const matcher = document.cookie.match(/chronoShop=\"shopId=([0-9]+)\";/);
    return matcher && matcher[1];
  }

  // TODO
  invalidPosCallback() {
    throw new Error(
      "You must implement 'invalidPosCallback' for this retailer"
    );
  }

  isAvailable() {
    return window.mealz.user.device.matchMedia("(min-width: 1023px)").matches;
  }

  // TODO: exclude irrelevant places
  availableOnShelf() {
    return !!document.getElementById('productListZone');
  }
}
